import React, { useEffect, useState } from 'react';
import { TablePagination } from '@material-ui/core';

const Pagination = props => {
  const { page, setPage, setOffset, totalCount } = props;
  const [rowsPerPage, setRowsPerPage] = useState(40);

  useEffect(() => {
    if (totalCount < 40) {
      setPage(0);
      setOffset(0);
    }
  }, [totalCount]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset((newPage > 0 && newPage * 40) || 0);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <div>
      <TablePagination
        rowsPerPageOptions={[40]}
        component="div"
        count={totalCount}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  );
};
export default Pagination;
